import { cn } from "@/lib/tailwind"
import Image from "next/image"

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  size?: number
  icon?: string | null | undefined
  bgColor?: string
  className?: string
}

export function ContentIcon({ size = 20, bgColor, icon, ...props }: Props) {
  if (!icon) return null
  return (
    <div
      {...props}
      style={{ background: bgColor ? `#${bgColor}` : "transparent", minWidth: size, width: size, height: size, ...props.style }}
      className={cn("flex h-full w-full items-center justify-center overflow-hidden rounded-full p-1.5", props.className)}
    >
      {icon.startsWith("<") ? (
        <div
          className="flex h-full w-full items-center justify-center [&>svg]:h-full [&>svg]:w-full"
          dangerouslySetInnerHTML={{ __html: icon }}
        />
      ) : (
        <Image width={size} height={size} src={icon} alt="icon" className="h-full w-full" />
      )}
    </div>
  )
}
